(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const getQuantityInput = () =>
    $('product-info quantity-input input[name="quantity"]') ||
    $('product-form input[name="quantity"]') ||
    $('input.quantity__input[name="quantity"]');

  const setQuantity = (quantity) => {
    const input = getQuantityInput();
    if (!input) return;
    input.value = quantity;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const initProductTools = () => {};
  const productInput = (form) => {
    const section = form.closest('product-info');
    return section?.querySelector('input[name="quantity"]') || form.querySelector('input[name="quantity"]');
  };
  document.addEventListener('click', (event) => {
    const tier = event.target.closest('[data-dm24-tier]');
    if (!tier) return;
    const input = tier.closest('product-info')?.querySelector('input[name="quantity"]');
    if (!input) return;
    input.value = Math.max(Number(input.min || 1), Number(tier.dataset.quantity));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.focus();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const wrapper = form.closest('product-form[data-dm24-minimum]');
    if (!wrapper) return;
    const minimum = Math.max(1, Number(wrapper.dataset.dm24Minimum || 1));
    const input = productInput(form);
    if (!input && minimum > 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (input && Number(input.value) < Math.max(minimum, Number(input.min || 1))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = Math.max(minimum, Number(input.min || 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
      input.reportValidity();
    }
  }, true);
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('input[data-dm24-minimum]')) return;
    const quantity = Number(input.value);
    const minimum = Math.max(1, Number(input.dataset.dm24Minimum || 1));
    if (!Number.isInteger(quantity) || (quantity > 0 && quantity < minimum)) {
      event.stopImmediatePropagation();
      input.value = minimum;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);
  const validateCartMinimums = () => {
    let invalid = false;
    $$('input[name="updates[]"][data-dm24-minimum]').forEach((input) => {
      const minimum = Number(input.dataset.dm24Minimum || 1);
      const quantity = Number(input.value);
      const row = input.closest('.cart-item');
      let note = row?.querySelector('.dm24-cart-error');
      if (quantity > 0 && quantity < minimum) {
        invalid = true;
        if (!note && row) {
          note = document.createElement('p');
          note.className = 'dm24-cart-error';
          note.setAttribute('role', 'alert');
          (row.querySelector('.cart-item__details') || row).append(note);
        }
        if (note) note.textContent = 'Mindestbestellmenge: ' + minimum + ' Stück. Bitte Menge anpassen oder Artikel entfernen.';
      } else note?.remove();
    });
    $$('[name="checkout"]').forEach((button) => {
      if (invalid) { button.disabled = true; button.dataset.dm24Blocked = 'true'; }
      else if (button.dataset.dm24Blocked) { button.disabled = false; delete button.dataset.dm24Blocked; }
    });
    $$('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach((container) => {
      if (invalid) { container.hidden = true; container.dataset.dm24Blocked = 'true'; }
      else if (container.dataset.dm24Blocked) { container.hidden = false; delete container.dataset.dm24Blocked; }
    });
    return !invalid;
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[name="checkout"]') && !validateCartMinimums()) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const parseConfig = () => {
    try {
      return JSON.parse($('#DM24CartConfig')?.textContent || '{}');
    } catch {
      return {};
    }
  };

  const formatMoney = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'CHF',
    }).format((Number(cents) || 0) / 100);

  const cartRequest = async (path, body) => {
    const response = await fetch(path, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };

  const getCartMount = () =>
    $('#main-cart-footer .cart__footer') ||
    $('.drawer__footer') ||
    $('.cart__footer');

  const renderGift = (cart, config, mount) => {
    const gift = config.gift || {};
    const eligibleTotal = cart.items.filter(item => item.properties?._dm24_gift !== 'true').reduce((sum,item) => sum + item.final_line_price,0);
    const panel = document.createElement('section');
    panel.className = 'dm24-cart-panel dm24-gift-panel';
    const shippingRemaining = Math.max(0,6000-eligibleTotal);
    panel.innerHTML = '<p><strong>' + (shippingRemaining ? 'Noch ' + formatMoney(shippingRemaining) + ' bis zum Gratisversand in der Schweiz.' : 'Ihr Versand in der Schweiz ist kostenlos.') + '</strong></p>';
    if (gift.enabled && gift.variantId && gift.thresholdCents) {
      const remaining = Math.max(0,gift.thresholdCents-eligibleTotal);
      const progress = Math.min(100,Math.round(eligibleTotal/gift.thresholdCents*100));
      const present = cart.items.some(item => item.properties?._dm24_gift === 'true' && item.final_line_price === 0);
      panel.innerHTML += '<div class="dm24-offer-card">' + (gift.image ? '<img src="' + escapeHtml(gift.image) + '" alt="' + escapeHtml(gift.title) + '" width="144" height="144">' : '') + '<div><h3>' + (present ? 'Ihr Gratisgeschenk ist dabei' : 'Ein Geschenk für Sie') + '</h3><p>' + escapeHtml(gift.title) + '</p><p>' + (remaining ? 'Noch ' + formatMoney(remaining) + ' bis zu Ihrem Gratisgeschenk.' : present ? 'Kostenlos zu Ihrer Bestellung hinzugefügt.' : 'Geschenk wird geprüft.') + '</p></div></div><div class="dm24-gift-progress" role="progressbar" aria-label="Fortschritt zum Gratisgeschenk" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + progress + '"><span style="--dm24-progress:' + progress + '%"></span></div>';
    }
    mount.prepend(panel);
  };

  const renderOffer = (cart, config, mount) => {
    const offer = config.offer || {};
    if (!offer.enabled || !offer.variantId) return;
    if (cart.items.some((item) => String(item.variant_id) === String(offer.variantId))) return;

    const discounted = Math.round(
      Number(offer.regularPriceCents || 0) * (100 - Number(offer.discountPercent || 0)) / 100
    );
    const panel = document.createElement('section');
    panel.className = 'dm24-cart-panel dm24-offer-panel';
    panel.innerHTML = `
      <div class="dm24-offer-card">
        ${offer.image ? `<img src="${offer.image}" alt="" width="144" height="144" loading="lazy">` : ''}
        <div>
          <h3>Nur jetzt im Warenkorb</h3>
          <p>${offer.title || 'Exklusives Zusatzangebot'}</p>
          <p class="dm24-offer-price">
            ${offer.discountPercent > 0 ? `${formatMoney(discounted)} statt ${formatMoney(offer.regularPriceCents)}` : formatMoney(offer.regularPriceCents)}
          </p>
          <button type="button" class="button button--secondary dm24-offer-add">Günstig dazu bestellen</button>
        </div>
      </div>
    `;
    $('.dm24-offer-add', panel)?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      try {
        await cartRequest(window.routes?.cart_add_url || '/cart/add.js', {
          items: [{
            id: Number(offer.variantId),
            quantity: 1,
            properties: { _dm24_cart_offer: 'true' },
          }],
        });
        const updatedCart = await cartRequest('/cart.js');
        const offerLine = updatedCart.items.find((item) => item.properties?._dm24_cart_offer === 'true');
        if (
          Number(offer.discountPercent || 0) > 0 &&
          offerLine &&
          offerLine.final_price >= offerLine.original_price
        ) {
          await cartRequest(window.routes?.cart_change_url || '/cart/change.js', {
            id: offerLine.key,
            quantity: 0,
          });
          throw new Error('Cart offer discount is not active');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.reload();
      } catch {
        button.disabled = false;
        button.textContent = 'Angebot derzeit nicht verfügbar';
      }
    });
    mount.prepend(panel);
  };

  const syncGift = async (cart, config) => {
    const gift = config.gift || {};
    if (!gift.enabled || !gift.variantId || !gift.thresholdCents) return cart;

    let giftLine = cart.items.find((item) => item.properties?._dm24_gift === 'true');
    if (giftLine && Number(giftLine.variant_id || giftLine.id) !== Number(gift.variantId)) {
      await cartRequest(window.routes?.cart_change_url || '/cart/change.js', { id: giftLine.key, quantity: 0 });
      cart = await cartRequest('/cart.js');
      giftLine = cart.items.find((item) => item.properties?._dm24_gift === 'true');
    }
    const eligibleTotal = cart.items
      .filter((item) => item.properties?._dm24_gift !== 'true')
      .reduce((sum, item) => sum + item.final_line_price, 0);
    const eligible = eligibleTotal >= Number(gift.thresholdCents);

    if (eligible && giftLine && giftLine.quantity === 1 && giftLine.final_line_price > 0) {
      await cartRequest(window.routes?.cart_change_url || '/cart/change.js', { id: giftLine.key, quantity: 0 });
      throw new Error('Free gift discount is not active');
    }

    if (eligible && !giftLine) {
      await cartRequest(window.routes?.cart_add_url || '/cart/add.js', {
        items: [{
          id: Number(gift.variantId),
          quantity: 1,
          properties: { _dm24_gift: 'true' },
        }],
      });
      const updatedCart = await cartRequest('/cart.js');
      const addedGift = updatedCart.items.find((item) => item.properties?._dm24_gift === 'true');
      if (!addedGift) throw new Error('Gift was not added');
      if (addedGift.final_line_price > 0) {
        await cartRequest(window.routes?.cart_change_url || '/cart/change.js', {
          id: addedGift.key,
          quantity: 0,
        });
        throw new Error('Free gift discount is not active');
      }
      return updatedCart;
    }

    if (eligible && giftLine && giftLine.quantity !== 1) {
      await cartRequest(window.routes?.cart_change_url || '/cart/change.js', { id: giftLine.key, quantity: 1 });
      return cartRequest('/cart.js');
    }

    if (!eligible && giftLine) {
      await cartRequest(window.routes?.cart_change_url || '/cart/change.js', {
        id: giftLine.key,
        quantity: 0,
      });
      return cartRequest('/cart.js');
    }

    return cart;
  };

  let cartUiRunning = false;
  const initCartTools = async () => {
    if (cartUiRunning) return;
    const mount = getCartMount();
    if (!mount) return;
    const config = parseConfig();


    cartUiRunning = true;
    try {
      let cart = await cartRequest('/cart.js');
      const before = JSON.stringify(cart.items.map(item => [item.key,item.quantity,item.final_line_price]));
      cart = await syncGift(cart, config);
      const after = JSON.stringify(cart.items.map(item => [item.key,item.quantity,item.final_line_price]));
      if (before !== after) {
        const drawer = $('cart-drawer');
        if (drawer && !$('#main-cart-footer')) {
          const response = await fetch((window.Shopify?.routes?.root || '/') + '?sections=cart-drawer,cart-icon-bubble');
          if (!response.ok) throw new Error('Cart sections could not be refreshed');
          const sections = await response.json();
          if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('Missing cart section');
          drawer.renderContents({ sections });
          drawer.classList.toggle('is-empty', cart.item_count === 0);
          validateCartMinimums();
        } else { window.location.reload(); return; }
      }
      const currentMount = getCartMount();
      if (!currentMount) return;
      $$('.dm24-cart-panel', currentMount).forEach((panel) => panel.remove());
      renderOffer(cart, config, currentMount);
      renderGift(cart, config, currentMount);
    } catch (error) {
      $$('.dm24-cart-panel', mount).forEach(panel => panel.remove());
      const note = document.createElement('p');
      note.className = 'dm24-cart-panel';
      note.setAttribute('role', 'status');
      note.textContent = 'Das Gratisgeschenk konnte noch nicht bestätigt werden. Bitte laden Sie den Warenkorb erneut.';
      mount.prepend(note);
      console.warn('[DM24] Warenkorb-Erweiterung konnte nicht geladen werden.', error);
    } finally {
      cartUiRunning = false;
    }
  };

  const hideEmptyCartRecommendations = () => {
    const emptyCart = $('.cart.is-empty, .is-empty .cart, .cart--empty');
    if (!emptyCart) return;
    const cartSection = emptyCart.closest('.shopify-section');
    if (!cartSection) return;
    let sibling = cartSection.nextElementSibling;
    while (sibling) {
      if (sibling.classList.contains('shopify-section')) sibling.setAttribute('hidden', '');
      sibling = sibling.nextElementSibling;
    }
  };

  const deduplicateFooterMenus = () => {
    const signatures = new Set();
    $$('.footer-block--menu').forEach((menu) => {
      const signature = $$('a', menu).map((link) => link.getAttribute('href')).filter(Boolean).join('|');
      if (!signature) return;
      if (signatures.has(signature)) menu.hidden = true;
      signatures.add(signature);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initProductTools();
    initCartTools();
    validateCartMinimums();
    deduplicateFooterMenus();
  });

  document.addEventListener('cart:refresh', initCartTools);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { setTimeout(() => { validateCartMinimums(); initCartTools(); }, 180); });
  }
  document.addEventListener('shopify:section:load', () => { validateCartMinimums(); initCartTools(); });
})();
